/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from '../Button.component';

import { AdapterButtonProps } from './AdapterButton.types';

const AdapterButtonBase = ({
  leftIcon,
  rightIcon,
  text,
  children,
  selected,
  isSelected,
  darkMode,
  'data-theme': dataTheme,
  ...props
}: AdapterButtonProps) => (
  <Button
    data-theme={darkMode ? 'dark' : dataTheme}
    children={
      children || (
        <>
          {leftIcon}
          {text}
          {rightIcon}
        </>
      )
    }
    selected={selected || isSelected}
    {...props}
  />
);
const AdapterButtonXS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_XS' as any} {...props} />
);
const AdapterButtonS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_S' as any} {...props} />
);
const AdapterButtonM = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_M' as any} {...props} />
);
const AdapterButtonL = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_L' as any} {...props} />
);

const PrimaryAdapterButton = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_S' as any} {...props} />
);
const PrimaryAdapterButtonXS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_XS' as any} {...props} />
);
const PrimaryAdapterButtonS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_S' as any} {...props} />
);
const PrimaryAdapterButtonM = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_M' as any} {...props} />
);
const PrimaryAdapterButtonL = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="primary" size={'DEPRECATED_L' as any} {...props} />
);

const SecondaryAdapterButton = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="secondary" size={'DEPRECATED_S' as any} {...props} />
);
const SecondaryAdapterButtonXS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="secondary" size={'DEPRECATED_XS' as any} {...props} />
);
const SecondaryAdapterButtonS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="secondary" size={'DEPRECATED_S' as any} {...props} />
);
const SecondaryAdapterButtonM = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="secondary" size={'DEPRECATED_M' as any} {...props} />
);
const SecondaryAdapterButtonL = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="secondary" size={'DEPRECATED_L' as any} {...props} />
);

const TertiaryAdapterButton = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="tertiary" size={'DEPRECATED_S' as any} {...props} />
);
const TertiaryAdapterButtonXS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="tertiary" size={'DEPRECATED_XS' as any} {...props} />
);
const TertiaryAdapterButtonS = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="tertiary" size={'DEPRECATED_S' as any} {...props} />
);
const TertiaryAdapterButtonM = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="tertiary" size={'DEPRECATED_M' as any} {...props} />
);
const TertiaryAdapterButtonL = (props: Omit<AdapterButtonProps, 'variant' | 'size'>) => (
  <AdapterButtonBase variant="tertiary" size={'DEPRECATED_L' as any} {...props} />
);

export const AdapterButton = Object.assign(AdapterButtonBase, {
  /** @deprecated replace with `<Button size="medium"></Button>` */
  XSmall: AdapterButtonXS,
  /** @deprecated replace with `<Button size="xlarge"></Button>` */
  Small: AdapterButtonS,
  /** @deprecated replace with `<Button size="xlarge"></Button>` */
  Medium: AdapterButtonM,
  /** @deprecated replace with `<Button size="xlarge"></Button>` */
  Large: AdapterButtonL,
  /** @deprecated replace with `<Button variant="primary"></Button>` */
  Primary: Object.assign(PrimaryAdapterButton, {
    /** @deprecated replace with `<Button variant="primary" size="medium"></Button>` */
    XSmall: PrimaryAdapterButtonXS,
    /** @deprecated replace with `<Button variant="primary" size="xlarge"></Button>` */
    Small: PrimaryAdapterButtonS,
    /** @deprecated replace with `<Button variant="primary" size="xlarge"></Button>` */
    Medium: PrimaryAdapterButtonM,
    /** @deprecated replace with `<Button variant="primary" size="xlarge"></Button>` */
    Large: PrimaryAdapterButtonL,
  }),
  /** @deprecated replace with `<Button variant="secondary"></Button>` */
  Secondary: Object.assign(SecondaryAdapterButton, {
    /** @deprecated replace with `<Button variant="secondary" size="medium"></Button>` */
    XSmall: SecondaryAdapterButtonXS,
    /** @deprecated replace with `<Button variant="secondary" size="xlarge"></Button>` */
    Small: SecondaryAdapterButtonS,
    /** @deprecated replace with `<Button variant="secondary" size="xlarge"></Button>` */
    Medium: SecondaryAdapterButtonM,
    /** @deprecated replace with `<Button variant="secondary" size="xlarge"></Button>` */
    Large: SecondaryAdapterButtonL,
  }),
  /** @deprecated replace with `<Button variant="tertiary"></Button>` */
  Tertiary: Object.assign(TertiaryAdapterButton, {
    /** @deprecated replace with `<Button variant="tertiary" size="medium"></Button>` */
    XSmall: TertiaryAdapterButtonXS,
    /** @deprecated replace with `<Button variant="tertiary" size="xlarge"></Button>` */
    Small: TertiaryAdapterButtonS,
    /** @deprecated replace with `<Button variant="tertiary" size="xlarge"></Button>` */
    Medium: TertiaryAdapterButtonM,
    /** @deprecated replace with `<Button variant="tertiary" size="xlarge"></Button>` */
    Large: TertiaryAdapterButtonL,
  }),
});
